import type {
  InventoryResource,
  Snapshot,
  AzureDisk,
  RestoreAccount,
} from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { AzureDiskConfiguration } from './steps/azureDiskConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreAzureDiskState {
  resourceId: string;
  snapshot: Snapshot;
  supportedCloudProviders: Provider[];
  restoreAccount?: RestoreAccount;
  resourceGroup?: string;
  location?: string;

  tags: Record<string, string>;
  initialTags: Record<string, string>;
  keepOriginalTags: boolean;
  initialDiskSettings: AzureDisk;
  diskSettings: AzureDisk;
  keepOriginalSettings?: boolean;
  resource?: InventoryResource;
}

const restoreAzureDiskFlow: Step<RestoreAzureDiskState> = {
  id: 'select_target_account_step',
  Component: SelectTargetAccountStep,
  next: [
    {
      id: 'azure_disk_configuration',
      Component: AzureDiskConfiguration,
    },
  ],
};

export const RestoreAzureDiskWizard = ({
  resource,
  snapshot,
  disk,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  disk: AzureDisk;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<RestoreAzureDiskState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreAzureDiskFlow]}
      initialState={{
        snapshot,
        resourceId: snapshot.resourceId,
        location: resource.region,
        resource,
        supportedCloudProviders: [Provider.Azure],
        initialDiskSettings: disk,
        diskSettings: disk,
        tags: snapshot.resource?.tags || {},
        initialTags: snapshot.resource?.tags || {},
        keepOriginalTags: true,
        keepOriginalSettings: true,
      }}
      title={`Restore disk`}
      stepperLabels={['Restore account', 'Disk configuration']}
    />
  );
};
